import React, { useState } from 'react'
import { Icon } from 'antd'
import CopyToClipboard from '../../shared/CopyToClipboard'
import FbaImagePreview from './FbaImagePreview'

const MAX_ITEMS = 3

const BATCH_STATUS_LABEL = {
    pending: 'Đang chờ',
    printing: 'Đang in',
    printed: 'Đã in',
    transferring: 'Đang ép',
    transferred: 'Đã ép',
    wait_to_sew: 'Chờ may',
    sewing: 'Đang may',
    completed: 'Hoàn thành',
    incomplete: 'Chưa hoàn thành',
}

const DESIGN_POSITIONS = [
    { key: 'design_front', label: 'front' },
    { key: 'design_back', label: 'back' },
    { key: 'design_hood', label: 'hood' },
    { key: 'design_sleeves', label: 'sleeves' },
]


const FbaItemDesignRow = ({ item, rowIndex }) => {
    const [showAll, setShowAll] = useState(false)

    const {
        namespace = '',
        order_number = '',
        preview_image = '',
        image = '',
        type = '',
        size = '',
        count = 0,
        items = [],
    } = item

    const availableDesigns = DESIGN_POSITIONS.filter(({ key }) => !!item[key])
    const displayItems = items.slice(0, MAX_ITEMS)
    const showMoreItems = items.slice(MAX_ITEMS)
    const allFacCodes = items.map(it => it.fac_code).join(' ')
    const uniqueBatches = items.reduce((acc, it) => {
        if (it.batch_name && !acc.some(b => b.batch_name === it.batch_name)) {
            acc.push({ batch_name: it.batch_name, batch_status: it.batch_status })
        }
        return acc
    }, [])

    return (
        <tr className='FbaItemDesignRow'>
            <td className='fba-col-store'>
                <div className='store-name'>{namespace}</div>
                <div className='order-code text-muted'>{order_number}</div>
            </td>

            <td className='fba-col-design'>
                {availableDesigns.length > 0 &&
                    availableDesigns.map(({ key, label }) => (
                        <div key={key} className='ItemSideDefault border rounded bg-white mb-1'>
                            <div className='px-2 py-1'>{label}</div>
                            <div className='border-top'>
                                <a href={item[key]} target='_blank' rel='noreferrer noopener'>
                                    <span className='Icon View p-2' title='View'><i className='fa fa-eye'/></span>
                                </a>
                                <CopyToClipboard
                                    text={item[key]}
                                    target={`copy_design_${rowIndex}_${key}`}
                                >
                                    <span className='Icon no-pointer-event p-2'><i className='fa fa-clone'/></span>
                                </CopyToClipboard>
                            </div>
                        </div>
                    ))
                }
                {availableDesigns.length === 0 && <span className='text-muted'>—</span>}
            </td>

            <td className='fba-col-image'>
                <FbaImagePreview url={preview_image} downloadUrl={image} />
            </td>

            <td className='fba-col-sku'>{type}</td>

            <td className='fba-col-size'>{size}</td>

            <td className='fba-col-quantity'>{count}</td>

            <td className='fba-col-detail'>
                <div className='d-flex align-items-center mb-1 barcode-item'>
                    <div className='d-flex flex-wrap'>
                        {displayItems.map((it, idx) => (
                            <span key={idx} className='badge badge-light barcode-badge mr-1 mb-1'>
                                {it.fac_code}
                            </span>
                        ))}
                    </div>
                    {items.length > 0 && (
                        <CopyToClipboard
                            text={allFacCodes}
                            target={`fba-copy-all-${rowIndex}`}
                        >
                            <Icon type='copy' className='copy-icon text-muted ml-1' />
                        </CopyToClipboard>
                    )}
                </div>

                {showAll && (
                    <div className='d-flex align-items-center mb-1 barcode-item'>
                        <div className='d-flex flex-wrap mt-1'>
                            {showMoreItems.map((it, idx) => (
                                <span key={idx} className='badge badge-light barcode-badge mr-1 mb-1'>
                                    {it.fac_code}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {!showAll && showMoreItems.length > 0 && (
                    <small
                        className='text-primary cursor-pointer'
                        onClick={() => setShowAll(true)}
                    >
                        Xem thêm ({showMoreItems.length})
                    </small>
                )}

                {showAll && showMoreItems.length > 0 && (
                    <small
                        className='text-primary cursor-pointer'
                        onClick={() => setShowAll(false)}
                    >
                        Thu gọn
                    </small>
                )}

                {items.length === 0 && (
                    <span className='text-muted'>—</span>
                )}
            </td>

            <td className='fba-col-batch'>
                {uniqueBatches.length > 0 ? (
                    uniqueBatches.map((it, idx) => (
                        <div key={idx} className='mb-1 batch-item-info'>
                            <div className='batch-info-box'>
                                <div className='batch-name mb-1'>
                                    <span>{it.batch_name}</span>
                                </div>
                                <div className='batch-status'>
                                    <span>{BATCH_STATUS_LABEL[it.batch_status] || it.batch_status}</span>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <span className='text-muted'>Chưa có lô</span>
                )}
            </td>
        </tr>
    )
}

export default FbaItemDesignRow
